/* ============================================================
 * DN — Filter drawer swatch cleanup
 *
 * Wevyr app injects inline styles with !important on any .swatch
 * element it finds, e.g.:
 *   background: rgb(229,229,229) !important;
 *   border: none !important;
 * This overrides our --swatch--background variable (which carries
 * the correct hex from the Color metaobject) and turns the swatch
 * gray. Since inline !important can't be beaten by stylesheet CSS,
 * we remove the injected properties via JS.
 *
 * Scope: only #filtersBox (drawer/sidebar). Leaves Wevyr's PDP and
 * product card swatches alone.
 *
 * Owner: FastCorp — rev 21 apr 2026
 * ============================================================ */

(function () {
  'use strict';

  var SELECTOR = '#filtersBox .swatch';
  var INJECTED_PROPS = ['background', 'border-width', 'border-style', 'border-color', 'border-image'];
  var obs = null;

  function cleanup() {
    if (obs) obs.disconnect();
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      for (var j = 0; j < INJECTED_PROPS.length; j++) {
        el.style.removeProperty(INJECTED_PROPS[j]);
      }
    }
    if (obs) {
      obs.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style']
      });
    }
  }

  function matches(node, sel) {
    return node && node.nodeType === 1 && node.matches && node.matches(sel);
  }

  function containsSwatch(node) {
    return node && node.nodeType === 1 && node.querySelector && node.querySelector(SELECTOR);
  }

  obs = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'attributes' && m.attributeName === 'style') {
        if (matches(m.target, SELECTOR)) {
          cleanup();
          return;
        }
      } else if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
        for (var k = 0; k < m.addedNodes.length; k++) {
          var n = m.addedNodes[k];
          if (matches(n, SELECTOR) || containsSwatch(n)) {
            cleanup();
            return;
          }
        }
      }
    }
  });

  function init() {
    cleanup();
    obs.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
